import { render, staticRenderFns } from "./RecycledTodoItem.vue?vue&type=template&id=508d3346&scoped=true&"
import script from "./RecycledTodoItem.vue?vue&type=script&lang=js&"
export * from "./RecycledTodoItem.vue?vue&type=script&lang=js&"
import style0 from "./RecycledTodoItem.vue?vue&type=style&index=0&id=508d3346&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508d3346",
  null
  
)

export default component.exports